import type { Stage } from "./Stage0Onramp";

/* SVG icons — thin outline style (Lucide-inspired), 20×20 */
const ICONS = {
  onramp: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>`,
  discovery: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>`,
  drilldown: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>`,
  playback: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>`,
  blueprint: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>`,
};

const STAGES: Array<{ icon: string; name: string; desc: string }> = [
  {
    icon: ICONS.onramp,
    name: "On-ramp",
    desc: "Tell us your intent and a few facts about your company.",
  },
  {
    icon: ICONS.discovery,
    name: "Discovery",
    desc: "A guided AI conversation to surface your biggest opportunities.",
  },
  {
    icon: ICONS.drilldown,
    name: "Drill-down",
    desc: "We go deeper on the use cases that matter most.",
  },
  {
    icon: ICONS.playback,
    name: "Playback",
    desc: "Review and refine the facts we've captured together.",
  },
  {
    icon: ICONS.blueprint,
    name: "Blueprint",
    desc: "Receive a ranked, actionable AI opportunity report.",
  },
];

function _buildJourneyStrip(): string {
  return STAGES.map((s, i) => {
    const connector =
      i > 0 ? `<div class="journey-connector" aria-hidden="true">→</div>` : "";
    return `
      ${connector}
      <div class="journey-step" role="listitem">
        <div class="journey-step-num" aria-hidden="true">${i + 1}</div>
        <div class="tile-icon" aria-hidden="true">${s.icon}</div>
        <h3>${s.name}</h3>
        <p>${s.desc}</p>
      </div>
    `;
  }).join("");
}

export class StageWelcome implements Stage {
  mount(container: HTMLElement): void {
    container.innerHTML = `
      <div class="onramp">
        <h1>Find out where AI can help your business.</h1>
        <p class="lede">A 10-minute guided AI discovery session — brought to you via Azure Marketplace.</p>

        <button class="btn primary welcome-cta" style="margin-bottom:var(--space-3xl);font-size:14px;padding:12px 24px;">
          Get Started
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </button>

        <div class="tile-section-label">How it works</div>
        <div class="journey-strip" role="list">
          ${_buildJourneyStrip()}
        </div>
      </div>
    `;

    container
      .querySelector<HTMLButtonElement>(".welcome-cta")!
      .addEventListener("click", () => {
        window.location.href = "/";
      });
  }

  unmount(): void {}
}
